module.exports = {"id":"155887","name":"Michael Bradley","rating":"78","photo":"./data/images/photos/2/155887.png","club":{"name":"Toronto FC","logo":"./data/images/clubs/TorontoFC.png"},"positions":["MDC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MichaelBradley0.json
// module id = 2979
// module chunks = 0